import React from 'react';
import moment from 'moment';
import { TAnnex6V2Record } from '../../../../../../../redux/app/annex6-v2/@types';
import { TAnnex6V2GroupG1 } from '../../../../../../../redux/app/annex6-v2/groups/group-g';
import Annex6V2TableRows from '../../_elements_v2/Annex6V2TableRows';

type OwnProps = {
    annex6V2Record: TAnnex6V2Record;
    isStrikedOff?: boolean;
    theme?: 'light' | 'dark';
};
type Annex6V2GroupG1PreviewProps = OwnProps;

function Annex6V2GroupG1Preview(props: Annex6V2GroupG1PreviewProps) {
    const record = props.annex6V2Record as TAnnex6V2GroupG1;
    const operationDate = moment(record.selectedDate, 'YYYY-MM-DD').format(
        'DD-MMM-YYYY'
    );
    const { itemG1P1, itemG1P2, itemG1P3 } = record;

    function renderMain() {
        const tableRows = [
            [operationDate, 'G', '1', renderItemP1()],
            [null, null, '2', renderItemP2()],
        ];

        if (record.remarks) {
            tableRows.push([null, null, 'NOTE', record.remarks]);
        }

        return (
            <Annex6V2TableRows
                record={record}
                tableRows={tableRows}
                theme={props.theme}
            />
        );
    }

    function renderItemP1() {
        const { date: smtDate, time: smtTime } = record.itemG1P1.receipt;
        const dateTimeLocal = `${smtDate}T${smtTime}:00${record.timeZone}`;
        const utcTime = moment.utc(dateTimeLocal);

        return (
            <h4 className="font-medium uppercase">
                Bunkering operation carried out on {utcTime.format('HH:mm')} hrs
                UTC on {utcTime.format('DD-MMM-YYYY')} ({smtTime} SMT on{' '}
                {moment(smtDate, 'YYYY-MM-DD').format('DD-MMM-YYYY')})
            </h4>
        );
    }

    function renderItemP2() {
        return (
            <h4 className="font-medium uppercase">
                Marpol sample seal number: {itemG1P3.marpolSampleSealNo}, BDN
                reference no: {itemG1P2.bdn}
            </h4>
        );
    }

    return renderMain();
}

export default Annex6V2GroupG1Preview;
